import { render } from "./ManageHighlights.vue?vue&type=template&id=335f76cc"
import script from "./ManageHighlights.vue?vue&type=script&lang=js"
export * from "./ManageHighlights.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__